import { Box, Typography } from '@mui/material';


export const FOOTER_H_MOBILE = 56;
export const FOOTER_H_DESKTOP = 64;

const APP_VERSION = process.env.REACT_APP_APP_VERSION || 'Unknown';

export default function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        mt: 'auto',
        height: { xs: FOOTER_H_MOBILE, md: FOOTER_H_DESKTOP },
        px: { xs: 2, md: 3 },
        bgcolor: '#ffffff',
        borderTop: '1px solid #f1f5f9',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        columnGap: 2,
        flexWrap: 'wrap',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'baseline', columnGap: 1 }}>
        <Typography
          variant="body2"
          sx={{ fontWeight: 600, color: '#475569', letterSpacing: 0.2 }}
        >
          AVATYE ANALYTICS
        </Typography>
        <Typography
          variant="caption"
          sx={{ color: '#94a3b8' }}
        >
          v{APP_VERSION}
        </Typography>
      </Box>
      <Box sx={{ lineHeight: 1.3 }}>
        <Typography variant="caption" sx={{ color: '#94a3b8' }}>
          © {new Date().getFullYear()} AVATYE. All rights reserved.
        </Typography>
      </Box>
    </Box>
  );
}
